export const commonComponentsPtBr = {
  detailSkeleton: { loading: 'Carregando' },
  errorState: {
    title: 'Não foi possível carregar',
    description: 'Verifique a conexão e tente novamente.',
    retry: 'Tentar novamente',
  },
  form: {
    // Proposed copy (UI-12), not yet approved by the client.
    discard: {
      proposedTitle: 'Descartar alterações?',
      proposedKeep: 'Continuar editando',
      proposedConfirm: 'Descartar',
      proposedBody: 'As alterações feitas nesta tela serão perdidas.',
    },
    // Proposed copy, not yet approved by the client.
    pending: {
      proposedTitle: 'Pendências',
      proposedNone: 'Nenhuma pendência',
      proposedCount_one: '{{count}} pendência',
      proposedCount_other: '{{count}} pendências',
      proposedStep: 'Etapa {{n}}',
      proposedDone: 'concluída',
      proposedHasIssues: 'com pendências',
      proposedResolved: 'resolvida',
      proposedBarPending_one: '{{count}} pendente',
      proposedBarPending_other: '{{count}} pendentes',
      proposedBarNone: 'nenhuma pendência',
      proposedBarError: 'com erros',
    },
  },
  accountPicker: {
    proposedResults: 'Contas',
    proposedShowChildren: 'Mostrar subcontas',
    proposedHideChildren: 'Ocultar subcontas',
  },
  pageShell: {
    breadcrumb: 'Trilha de navegação',
    pageTabs: 'Seções da página',
    more: 'Mais {{count}}',
    moreTabs: 'Mais {{count}} seções da página',
    moreActions: 'Mais ações',
    loading: 'Carregando…',
  },
  listingTabs: {
    more: 'Mais {{count}}',
    // Said after the pill's visible text, so its name starts with what it shows.
    moreName: 'abas da lista',
    unifiedName: 'abas e visualizações salvas',
    tabsGroup: 'Abas da lista',
    // A saved view's tab: the view's name, said as a saved view.
    savedView: 'Visão salva: {{name}}',
    search: 'Buscar aba…',
    empty: 'Nada encontrado',
  },
  dataTable: {
    actions: 'Ações',
    savedViews: {
      group: 'Visões salvas',
      // Contas a pagar's copy (BillsSimpleSavedViewsControls), word for word.
      save: 'Salvar visualização',
      saveTitle: 'Salvar visão atual',
      name: 'Nome',
      scope: 'Quem vê',
      private: 'Só eu',
      tenant: 'Toda a empresa',
      cancel: 'Cancelar',
      confirm: 'Salvar',
      delete: 'Excluir visualização',
      deleteTip: 'Excluir esta visualização',
      deleteTitle: 'Excluir esta visualização?',
      deleteDescription: 'Esta ação não pode ser desfeita.',
      visibility: 'Visibilidade da visualização salva',
      privateShort: 'Privada',
      privateTip: 'Somente você vê e usa esta visualização.',
      sharedShort: 'Compartilhada',
      sharedTip: 'Toda a organização pode ver e usar esta visualização.',
      more: 'Mais ações da visualização',
      deleteConfirm: 'Excluir',
      setDefault: 'Definir como visualização padrão ao abrir a lista',
      unsetDefault: 'Remover como visualização padrão',
      saveError: 'Não foi possível salvar a visualização. Tente novamente.',
      actionError: 'Não foi possível atualizar a visualização. Tente novamente.',
    },
    groups: {
      selectGroup_m: 'Selecionar todos de {{label}}',
      selectGroup_f: 'Selecionar todas de {{label}}',
      countThisPage: '{{count}} {{noun}} nesta página',
      countThisPageShort: '{{count}} nesta página',
      item_one: 'item',
      item_other: 'itens',
    },
    expand: { header: 'Detalhes', expand: 'Expandir {{label}}', collapse: 'Recolher {{label}}' },
    filterMenu: {
      trigger: 'Mais filtros',
      triggerActive: 'Mais filtros (filtro ativo)',
    },
    columns: {
      trigger: 'Colunas',
      triggerTooltip: 'Colunas da tabela',
      title: 'Colunas',
      defaultsHint: 'Marque ou desmarque as colunas exibidas na tabela.',
      reorderHint:
        'Arraste pela alça, ou use Alt+↑/↓ com ela em foco, para alterar a ordem das colunas.',
      resetOrder: 'Restaurar ordem padrão',
      dragHandle: 'Reordenar coluna',
      moved: '{{column}} movida para a posição {{position}} de {{total}}',
      dataType: {
        date: 'Data',
        text: 'Texto',
        status: 'Status',
        currency: 'Valor',
        classification: 'Classificação',
        boolean: 'Sim/Não',
        payment: 'Pagamento',
        actions: 'Ações',
      },
    },
    pagination: {
      label: 'Paginação',
      summary_zero: 'Página {{page}} de {{pages}} • {{count}} resultados',
      summary_one: 'Página {{page}} de {{pages}} • {{count}} resultado',
      summary_other: 'Página {{page}} de {{pages}} • {{count}} resultados',
      previous: 'Anterior',
      next: 'Próxima',
      pageSize: 'Linhas por página',
      perPage: '{{size}} / página',
    },
    selection: {
      region: 'Linhas selecionadas',
      // The noun's gender inflects "selecionado/a" and "todos/todas" (context m / f).
      count_m_one: '{{count}} {{noun}} selecionado',
      count_m_other: '{{count}} {{noun}} selecionados',
      count_f_one: '{{count}} {{noun}} selecionada',
      count_f_other: '{{count}} {{noun}} selecionadas',
      countThisPage_m_one: '{{count}} {{noun}} selecionado nesta página',
      countThisPage_m_other: '{{count}} {{noun}} selecionados nesta página',
      countThisPage_f_one: '{{count}} {{noun}} selecionada nesta página',
      countThisPage_f_other: '{{count}} {{noun}} selecionadas nesta página',
      selectAllInGroup_m: 'Selecionar todos os {{count}} de {{label}}',
      selectAllInGroup_f: 'Selecionar todas as {{count}} de {{label}}',
      allInGroup_m: 'Todos os {{count}} de {{label}} selecionados',
      allInGroup_f: 'Todas as {{count}} de {{label}} selecionadas',
      selectAllMatching_m: 'Selecionar todos os {{count}}',
      selectAllMatching_f: 'Selecionar todas as {{count}}',
      allMatchingSelected_m_one: '{{count}} {{noun}} selecionado em todas as páginas',
      allMatchingSelected_m_other: 'Todos os {{count}} {{noun}} selecionados',
      allMatchingSelected_f_one: '{{count}} {{noun}} selecionada em todas as páginas',
      allMatchingSelected_f_other: 'Todas as {{count}} {{noun}} selecionadas',
      moreActions: 'Mais ações',
      clear: 'Limpar seleção',
      selectPage_m: 'Selecionar todos da página',
      selectPage_f: 'Selecionar todas da página',
      selectRow: 'Selecionar {{label}}',
    },
    states: {
      loading: 'Carregando',
      emptyTitle: 'Nenhum registro ainda',
      noResultsTitle: 'Nenhum resultado',
      noResultsDescription: 'Nenhum registro corresponde aos filtros aplicados.',
      clearFilters: 'Limpar filtros',
      errorTitle: 'Não foi possível carregar',
      errorDescription: 'Verifique a conexão e tente novamente.',
      retry: 'Tentar novamente',
    },
    filters: {
      filterBy: 'Filtrar {{column}}',
      filterByActive: 'Filtrar {{column}} (filtro ativo)',
      applied: 'Filtros aplicados',
      activeLabel: 'Filtros ativos:',
      on: 'Sim',
      clearAll: 'Limpar todos',
      apply: 'Aplicar',
      clear: 'Limpar',
      searchIn: 'Buscar em {{column}}',
      searchPlaceholder: 'Buscar…',
      noMatches: 'Nenhum resultado encontrado.',
      loading: 'Carregando…',
      operator: 'Operador',
      value: 'Valor',
      valueTo: 'Até o valor',
      invalidAmount: 'Informe um valor, como 1.500,00',
      invalidWholeNumber: 'Informe um número inteiro, como 3',
      dateRange: 'Período',
      between: '{{from}} a {{to}}',
      since: 'A partir de {{from}}',
      until: 'Até {{to}}',
      operators: {
        eq: 'Igual a',
        gt: 'Maior que',
        gte: 'Maior ou igual a',
        lt: 'Menor que',
        lte: 'Menor ou igual a',
        between: 'Entre',
      },
    },
    sort: {
      ascending: 'Ordenado do menor para o maior',
      descending: 'Ordenado do maior para o menor',
      sortBy: 'Ordenar por {{column}}',
    },
    density: { label: 'Densidade das linhas', compact: 'Compacta', regular: 'Padrão' },
  },
  filterChip: { remove: 'Remover filtro {{label}}: {{value}}' },
  restrictedResource: {
    title: {
      record: 'Registro não disponível',
      bankAccount: 'Conta bancária não disponível',
      bill: 'Fatura não disponível',
      vendor: 'Fornecedor não disponível',
      glAccount: 'Conta contábil não disponível',
    },
    // Deliberately covers both cases at once: the API answers a denied read the
    // same way it answers a missing record, and the screen must not reveal which.
    description:
      'Este registro não existe ou não foi compartilhado com você. Se precisar de acesso, peça a quem administra os dados protegidos.',
    errorTitle: 'Não foi possível carregar',
    back: 'Voltar para a listagem',
    retry: 'Tentar novamente',
  },
  emptyState: {
    default: {
      title: 'Nenhum item encontrado',
      description: 'Não há itens para exibir no momento.',
    },
    search: {
      title: 'Nenhum resultado encontrado',
      description: 'Tente ajustar os termos da busca.',
    },
    filter: {
      title: 'Nenhum resultado',
      description: 'Nenhum item corresponde aos filtros selecionados.',
    },
    data: {
      title: 'Sem dados',
      description: 'Não há dados disponíveis ainda.',
    },
    error: {
      title: 'Erro ao carregar',
      description: 'Não foi possível carregar os dados. Tente novamente.',
    },
    entity: {
      noEntityFound: 'Nenhum {{entityName}} encontrado',
      noEntitiesRegistered: 'Não há {{entityName}}s cadastrados ainda.',
      addEntity: 'Adicionar {{entityName}}',
      import: 'Importar',
    },
  },
  confirmDialog: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    processing: 'Processando...',
    processingTitle: 'Processando ação',
    processingDescription: 'Aguarde enquanto concluímos esta ação.',
    successTitle: 'Ação concluída',
    successDescription: 'A ação foi concluída com sucesso.',
    errorTitle: 'Não foi possível concluir',
    done: 'Concluir',
    close: 'Fechar',
    retry: 'Tentar novamente',
  },
  inlineTextarea: {
    save: 'Salvar',
  },
  datePicker: {
    label: 'Data',
    clear: 'Limpar',
    today: 'Hoje',
    apply: 'Aplicar',
    thisMonth: 'Este mês',
    monthPlaceholder: 'Selecione o mês',
    presetTodayOnly: 'Apenas hoje',
    presetLast7Days: 'Últ. 7 dias',
    presetLast30Days: 'Últ. 30 dias',
    presetNextWeek: 'Próxima semana',
    untilDate: 'até {{date}}',
  },
  userSelector: {
    selectSinglePlaceholder: 'Selecione um usuário',
    selectMultiplePlaceholder: 'Selecione usuários',
    searchPlaceholder: 'Buscar por nome ou email...',
    emptyText: 'Nenhuma pessoa encontrada.',
    errorText: 'Erro ao carregar usuários.',
    clearSelection: 'Limpar seleção',
    changeSelection: 'Alterar',
    selectAction: 'Selecionar',
    addAction: 'Adicionar',
  },
  financialInstitutionSelector: {
    placeholder: 'Buscar por nome ou código...',
    searchInputLabel: 'Buscar banco',
    searchInputLabelWithField: 'Buscar {{field}}',
    loadingText: 'Buscando bancos...',
    emptyText: 'Nenhum banco encontrado.',
    errorText: 'Erro ao carregar instituições financeiras.',
  },
  bankAccountSelector: {
    emptyText: 'Nenhuma conta encontrada',
  },
  goldDustLoader: {
    label: 'Carregando',
  },
  elixirLoader: {
    defaultLabel: 'Destilando insights...',
    doneLabel: 'Análise concluída',
    errorLabel: 'Análise interrompida',
  },
};

export const commonComponentsEn = {
  detailSkeleton: { loading: 'Loading' },
  errorState: {
    title: 'Could not load',
    description: 'Check your connection and try again.',
    retry: 'Try again',
  },
  form: {
    // Proposed copy (UI-12), not yet approved by the client.
    discard: {
      proposedTitle: 'Discard changes?',
      proposedKeep: 'Keep editing',
      proposedConfirm: 'Discard',
      proposedBody: 'Changes made on this screen will be lost.',
    },
    // Proposed copy, not yet approved by the client.
    pending: {
      proposedTitle: 'Pending',
      proposedNone: 'Nothing pending',
      proposedCount_one: '{{count}} pending item',
      proposedCount_other: '{{count}} pending items',
      proposedStep: 'Step {{n}}',
      proposedDone: 'done',
      proposedHasIssues: 'has pending items',
      proposedResolved: 'resolved',
      proposedBarPending_one: '{{count}} pending',
      proposedBarPending_other: '{{count}} pending',
      proposedBarNone: 'nothing pending',
      proposedBarError: 'has errors',
    },
  },
  accountPicker: {
    proposedResults: 'Accounts',
    proposedShowChildren: 'Show sub-accounts',
    proposedHideChildren: 'Hide sub-accounts',
  },
  pageShell: {
    breadcrumb: 'Breadcrumb',
    pageTabs: 'Page sections',
    more: '{{count}} more',
    moreTabs: '{{count}} more page sections',
    moreActions: 'More actions',
    loading: 'Loading…',
  },
  listingTabs: {
    more: '{{count}} more',
    // Said after the pill's visible text, so its name starts with what it shows.
    moreName: 'list tabs',
    unifiedName: 'tabs and saved views',
    tabsGroup: 'List tabs',
    // A saved view's tab: the view's name, said as a saved view.
    savedView: 'Saved view: {{name}}',
    search: 'Search for a tab…',
    empty: 'No matches',
  },
  dataTable: {
    actions: 'Actions',
    savedViews: {
      group: 'Saved views',
      save: 'Save view',
      saveTitle: 'Save current view',
      name: 'Name',
      scope: 'Who sees it',
      private: 'Only me',
      tenant: 'The whole company',
      cancel: 'Cancel',
      confirm: 'Save',
      delete: 'Delete view',
      deleteTip: 'Delete this view',
      deleteTitle: 'Delete this view?',
      deleteDescription: 'This action cannot be undone.',
      visibility: 'Saved view visibility',
      privateShort: 'Private',
      privateTip: 'Only you see and use this view.',
      sharedShort: 'Shared',
      sharedTip: 'Everyone in the organization can see and use this view.',
      more: 'More view actions',
      deleteConfirm: 'Delete',
      setDefault: 'Set as the default view when opening the list',
      unsetDefault: 'Remove as the default view',
      saveError: 'Could not save the view. Try again.',
      actionError: 'Could not update the view. Try again.',
    },
    groups: {
      selectGroup_m: 'Select all of {{label}}',
      selectGroup_f: 'Select all of {{label}}',
      countThisPage: '{{count}} {{noun}} on this page',
      countThisPageShort: '{{count}} on this page',
      item_one: 'item',
      item_other: 'items',
    },
    expand: { header: 'Details', expand: 'Expand {{label}}', collapse: 'Collapse {{label}}' },
    filterMenu: {
      trigger: 'More filters',
      triggerActive: 'More filters (filter active)',
    },
    columns: {
      trigger: 'Columns',
      triggerTooltip: 'Table columns',
      title: 'Columns',
      defaultsHint: 'Check or uncheck columns to show in the table.',
      reorderHint: 'Drag the handle, or press Alt+↑/↓ while it has focus, to reorder columns.',
      resetOrder: 'Reset column order',
      dragHandle: 'Reorder column',
      moved: '{{column}} moved to position {{position}} of {{total}}',
      dataType: {
        date: 'Date',
        text: 'Text',
        status: 'Status',
        currency: 'Amount',
        classification: 'Classification',
        boolean: 'Yes/No',
        payment: 'Payment',
        actions: 'Actions',
      },
    },
    pagination: {
      label: 'Pagination',
      summary_zero: 'Page {{page}} of {{pages}} • {{count}} results',
      summary_one: 'Page {{page}} of {{pages}} • {{count}} result',
      summary_other: 'Page {{page}} of {{pages}} • {{count}} results',
      previous: 'Previous',
      next: 'Next',
      pageSize: 'Rows per page',
      perPage: '{{size}} / page',
    },
    selection: {
      region: 'Selected rows',
      // English does not inflect: the same words for either gender (keys mirror pt-BR's).
      count_m_one: '{{count}} {{noun}} selected',
      count_m_other: '{{count}} {{noun}} selected',
      count_f_one: '{{count}} {{noun}} selected',
      count_f_other: '{{count}} {{noun}} selected',
      countThisPage_m_one: '{{count}} {{noun}} selected on this page',
      countThisPage_m_other: '{{count}} {{noun}} selected on this page',
      countThisPage_f_one: '{{count}} {{noun}} selected on this page',
      countThisPage_f_other: '{{count}} {{noun}} selected on this page',
      selectAllInGroup_m: 'Select all {{count}} of {{label}}',
      selectAllInGroup_f: 'Select all {{count}} of {{label}}',
      allInGroup_m: 'All {{count}} of {{label}} selected',
      allInGroup_f: 'All {{count}} of {{label}} selected',
      selectAllMatching_m: 'Select all {{count}}',
      selectAllMatching_f: 'Select all {{count}}',
      allMatchingSelected_m_one: '{{count}} {{noun}} selected across all pages',
      allMatchingSelected_m_other: 'All {{count}} {{noun}} selected',
      allMatchingSelected_f_one: '{{count}} {{noun}} selected across all pages',
      allMatchingSelected_f_other: 'All {{count}} {{noun}} selected',
      moreActions: 'More actions',
      clear: 'Clear selection',
      selectPage_m: 'Select all on this page',
      selectPage_f: 'Select all on this page',
      selectRow: 'Select {{label}}',
    },
    states: {
      loading: 'Loading',
      emptyTitle: 'No records yet',
      noResultsTitle: 'No results',
      noResultsDescription: 'No records match the applied filters.',
      clearFilters: 'Clear filters',
      errorTitle: 'Could not load',
      errorDescription: 'Check your connection and try again.',
      retry: 'Try again',
    },
    filters: {
      filterBy: 'Filter {{column}}',
      filterByActive: 'Filter {{column}} (filter active)',
      applied: 'Applied filters',
      activeLabel: 'Active filters:',
      on: 'Yes',
      clearAll: 'Clear all',
      apply: 'Apply',
      clear: 'Clear',
      searchIn: 'Search {{column}}',
      searchPlaceholder: 'Search…',
      noMatches: 'No results found.',
      loading: 'Loading…',
      operator: 'Operator',
      value: 'Value',
      valueTo: 'Up to value',
      invalidAmount: 'Enter an amount, such as 1,500.00',
      invalidWholeNumber: 'Enter a whole number, such as 3',
      dateRange: 'Period',
      between: '{{from}} to {{to}}',
      since: 'From {{from}}',
      until: 'Until {{to}}',
      operators: {
        eq: 'Equal to',
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        lt: 'Less than',
        lte: 'Less than or equal to',
        between: 'Between',
      },
    },
    sort: {
      ascending: 'Sorted ascending',
      descending: 'Sorted descending',
      sortBy: 'Sort by {{column}}',
    },
    density: { label: 'Row density', compact: 'Compact', regular: 'Regular' },
  },
  filterChip: { remove: 'Remove filter {{label}}: {{value}}' },
  restrictedResource: {
    title: {
      record: 'Record not available',
      bankAccount: 'Bank account not available',
      bill: 'Bill not available',
      vendor: 'Vendor not available',
      glAccount: 'GL account not available',
    },
    description:
      'This record either does not exist or has not been shared with you. If you need access, ask whoever administers protected data.',
    errorTitle: 'Unable to load',
    back: 'Back to list',
    retry: 'Try again',
  },
  emptyState: {
    default: {
      title: 'No items found',
      description: 'There are no items to display at the moment.',
    },
    search: {
      title: 'No results found',
      description: 'Try adjusting your search terms.',
    },
    filter: {
      title: 'No results',
      description: 'No items match the selected filters.',
    },
    data: {
      title: 'No data',
      description: 'No data is available yet.',
    },
    error: {
      title: 'Error loading',
      description: 'Unable to load the data. Please try again.',
    },
    entity: {
      noEntityFound: 'No {{entityName}} found',
      noEntitiesRegistered: 'No {{entityName}}s registered yet.',
      addEntity: 'Add {{entityName}}',
      import: 'Import',
    },
  },
  confirmDialog: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    processing: 'Processing...',
    processingTitle: 'Processing action',
    processingDescription: 'Please wait while we complete this action.',
    successTitle: 'Action completed',
    successDescription: 'The action was completed successfully.',
    errorTitle: 'Unable to complete action',
    done: 'Done',
    close: 'Close',
    retry: 'Try again',
  },
  inlineTextarea: {
    save: 'Save',
  },
  datePicker: {
    label: 'Date',
    clear: 'Clear',
    today: 'Today',
    apply: 'Apply',
    thisMonth: 'This month',
    monthPlaceholder: 'Select month',
    presetTodayOnly: 'Today only',
    presetLast7Days: 'Last 7 days',
    presetLast30Days: 'Last 30 days',
    presetNextWeek: 'Next week',
    untilDate: 'until {{date}}',
  },
  userSelector: {
    selectSinglePlaceholder: 'Select a user',
    selectMultiplePlaceholder: 'Select users',
    searchPlaceholder: 'Search by name or email...',
    emptyText: 'No people found.',
    errorText: 'Error loading users.',
    clearSelection: 'Clear selection',
    changeSelection: 'Change',
    selectAction: 'Select',
    addAction: 'Add',
  },
  financialInstitutionSelector: {
    placeholder: 'Search by name or code...',
    searchInputLabel: 'Search bank',
    searchInputLabelWithField: 'Search {{field}}',
    loadingText: 'Searching banks...',
    emptyText: 'No banks found.',
    errorText: 'Unable to load financial institutions.',
  },
  bankAccountSelector: {
    emptyText: 'No accounts found',
  },
  goldDustLoader: {
    label: 'Loading',
  },
  elixirLoader: {
    defaultLabel: 'Distilling insights...',
    doneLabel: 'Analysis complete',
    errorLabel: 'Analysis stopped',
  },
};
